(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

!(function (d) {
    var cartData = d.getElementById('cart-data-element');
    var membershipIds = [
        cartData.dataset.monthlyid,
        cartData.dataset.annualid,
        cartData.dataset.twoyearid
    ];

    var removeButtons = d.getElementsByClassName('cart-product-remove');
    for (var i = 0; i < removeButtons.length; i++) {
        var button = removeButtons[i];
        if (membershipIds.includes(button.dataset.varientid)) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var removeUrl = e.target.href;
                var modalButton = d.getElementById('remove-membership-continue');
                modalButton.setAttribute('href', removeUrl);
                var modal = d.getElementById('cart-remove-membership-modal');
                modal.style.display = 'block';
            });
        }
    }

    // Prevent the page from reloading when clicking on the minus button
    // when there is only one of the product left
    $('.product-minus').each((index, element) => {
        var input = $(element).siblings('input');
        var quantity = input.val();
        if (quantity == 0 ) {
            $(element).addClass('disabled');
            $(element).click((e) => {
                e.preventDefault();
                e.stopPropagation();
            });
        }
    });

}(document));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credera-homepage-endorsements"]) return;
  try {
    
  $(document).ready(function() {
    $('.endorsement-list').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="previous carousel-control" type="button" aria-label="Previous"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Left Arrow</title><path d="m22.5 4.563h-17.385l1.941-1.9215c0.13933-0.13708 0.24999-0.30047 0.32552-0.48074s0.11442-0.37373 0.11442-0.56919c0-0.19545-0.03889-0.389-0.11442-0.56927s-0.18619-0.34367-0.32551-0.48074c-0.2827-0.27912-0.66397-0.43561-1.0612-0.43561-0.39727-1e-6 -0.77856 0.15649-1.0612 0.43561l-4.5 4.4565c-0.12624 0.12732-0.22793 0.27674-0.3 0.44091-0.020738 0.04881-0.038281 0.09897-0.052505 0.15006-0.04049 0.11817-0.064718 0.24133-0.072006 0.36603-0.003628 0.04993-0.003628 0.10003-2e-8 0.14996 0.0045823 0.15948 0.035506 0.31707 0.091506 0.46646 0.002795 0.01368 0.006305 0.02725 0.010506 0.04056 0.073035 0.1623 0.17465 0.31018 0.3 0.43652 0.012 0.0135 0.016507 0.03146 0.030007 0.04496l4.5 4.4565c0.28289 0.2788 0.66408 0.435 1.0612 0.435 0.39716 0 0.77837-0.1562 1.0613-0.435 0.13932-0.1371 0.24999-0.3005 0.32552-0.4808s0.11441-0.3737 0.11441-0.5692-0.03888-0.3889-0.11441-0.56918c-0.07553-0.18027-0.1862-0.34376-0.32552-0.48084l-1.941-1.9215 17.378 1e-5c0.2016 0.01111 0.4033-0.01895 0.5928-0.08844 0.1896-0.0695 0.363-0.1769 0.5096-0.31568 0.1467-0.13877 0.2635-0.30601 0.3433-0.49145 0.0798-0.18545 0.121-0.38524 0.121-0.58713s-0.0412-0.40168-0.121-0.58713c-0.0798-0.18544-0.1966-0.35267-0.3433-0.49145-0.1466-0.13878-0.32-0.24618-0.5096-0.31568-0.1895-0.06949-0.3912-0.09964-0.5928-0.08853z" clip-rule="evenodd" class="fill" fill="#fff" fill-rule="evenodd"/></svg></button>',
      nextArrow: '<button class="next carousel-control" type="button" aria-label="Next"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Right Arrow</title><path d="m1.4999 4.563h17.385l-1.941-1.9215c-0.1393-0.13708-0.25-0.30047-0.3255-0.48074s-0.1144-0.37373-0.1144-0.56919c0-0.19545 0.0389-0.389 0.1144-0.56927s0.1862-0.34367 0.3255-0.48074c0.2827-0.27912 0.664-0.43561 1.0613-0.43561 0.3972-1e-6 0.7785 0.15649 1.0612 0.43561l4.5 4.4565c0.1263 0.12732 0.228 0.27674 0.3 0.44091 0.0208 0.04881 0.0383 0.09897 0.0525 0.15006 0.0405 0.11817 0.0647 0.24133 0.072 0.36603 0.0037 0.04993 0.0037 0.10003 0 0.14996-0.0045 0.15948-0.0355 0.31707-0.0915 0.46646-0.0028 0.01368-0.0063 0.02725-0.0105 0.04056-0.073 0.1623-0.1746 0.31018-0.3 0.43652-0.012 0.0135-0.0165 0.03146-0.03 0.04496l-4.5 4.4565c-0.2829 0.2788-0.6641 0.435-1.0612 0.435-0.3972 0-0.7784-0.1562-1.0613-0.435-0.1393-0.1371-0.25-0.3005-0.3255-0.4808s-0.1144-0.3737-0.1144-0.5692 0.0389-0.3889 0.1144-0.56918c0.0755-0.18027 0.1862-0.34376 0.3255-0.48084l1.941-1.9215-17.377 1e-5c-0.20159 0.01111-0.40332-0.01895-0.59287-0.08844-0.18956-0.0695-0.36297-0.1769-0.5096-0.31568-0.14664-0.13877-0.26343-0.30601-0.34325-0.49145-0.079821-0.18545-0.12099-0.38524-0.12099-0.58713s0.041164-0.40168 0.12098-0.58713c0.079823-0.18544 0.19662-0.35267 0.34325-0.49145 0.14664-0.13878 0.32005-0.24618 0.50961-0.31568 0.18955-0.06949 0.39128-0.09964 0.59287-0.08853z" clip-rule="evenodd" fill="#fff" class="fill" fill-rule="evenodd"/></svg></button>',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credera-homepage-video-hero"] && !window.DesignMode) return;
  try {
    
  (function () {
    $("#homepageScrollDown").click(function(e) {
      e.preventDefault();
      var divId = $(this).attr("href");

      let el = document.querySelector(divId);

      if (el) {
        el.scrollIntoView({ behavior: 'smooth', alignment: 'top'});
      }
    });  
  })(); 




  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Echelon-compare-test"]) return;
  try {
    
        $(() => {
            // INITIALIZE VARIABLES
            let numPeople = null;
            let curCost = null;
            let numWorkouts = null;
            let travelTime = null;

            // KEEP TRACK OF QUESTION NUMBER
            let questionNum = 1

            // FEATURES ARRAY
            const features = [
                { name: 'Heartrate Monitor', price: '59.99' },
                { name: 'Earbuds', price: '59.99' },
                { name: 'Chest Heart Monitor', price: '39.99' },
                { name: 'Water Bottle', price: '12.99' },
                { name: 'Competition Seat', price: '29.99' },
                { name: 'Oversized Seat', price: '29.99' },
                { name: 'Gel Seat Cover', price: '19.99' },
                { name: 'SPD Pedals', price: '59.99' },
                { name: 'Bike Shoes', price: '99.99' }
            ]

            // CHOSEN FEATURES
            let chosenFeatures = [];

            // IMAGE ARRAY
            const imageArray = [
                "https://cdn.shopify.com/s/files/1/2422/9487/files/EchelonConnectBikes_800x.jpg?v=1598014121",
                "https://cdn.shopify.com/s/files/1/2422/9487/files/reflectHomeSec_800x.png?v=1598291438",
                "https://cdn.shopify.com/s/files/1/2422/9487/files/Image-2_800x.jpg?v=1598013841",
                "https://cdn.shopify.com/s/files/1/2422/9487/files/Echelon_Stride_-_Lifestyle_-_Class_Screen_1-1201x801-d21b45d_800x.jpg?v=1617885704",
                "https://cdn.shopify.com/s/files/1/2422/9487/files/connectUi_400x320_crop_center.jpg?v=1598031228"
            ]

            // GRAB THE IMAGE
            const imageElement = $("#image");

            // GRAB BREADCRUMBS
            const firstBreadcrumb = $("#firstBreadcrumb");
            const secondBreadcrumb = $("#secondBreadcrumb");
            const thirdBreadcrumb = $("#thirdBreadcrumb");
            const fourthBreadcrumb = $("#fourthBreadcrumb");
            const fifthBreadcrumb = $("#fifthBreadcrumb");

            // GRAB ALL BREADCRUMBS
            const allBreadCrumbs = $(".breadCrumb");

            // ARRAY OF BREADCRUMBS
            const breadcrumbsArray = [firstBreadcrumb, secondBreadcrumb, thirdBreadcrumb, fourthBreadcrumb, fifthBreadcrumb];

            // GRAB CONTAINERS
            const peopleContainer = $("#peopleContainer");
            const costContainer = $("#costContainer");
            const workoutContainer = $("#workoutContainer");
            const travelContainer = $("#travelContainer");
            const productContainer = $("#productContainer");
            const featureTags = $("#featureTags");

            // ARRAY OF CONTAINERS
            const containersArray = [peopleContainer, costContainer, workoutContainer, travelContainer, productContainer];

            // HIDE CONTAINERS
            costContainer.hide();
            workoutContainer.hide();
            travelContainer.hide();
            productContainer.hide();

            // GRAB INPUTS AND BUTTONS
            const totalPeopleInput = $("#totalPeople");
            const totalCostInput = $("#cost");
            const totalWorkoutsInput = $("#weeklyWorkouts");
            const totalTravelInput = $("#travelTime");
            const nextBtn = $("#nextBtn");
            const backBtn = $("#backBtn");
            const calcBtn = $("#calcBtn");

            // ADD FEATURE TAGS TO PRODUCT CONTAINER
            features.map(feature => featureTags.append(`<div id=${JSON.stringify(feature.name)} class="feature"><input class="featureCheckbox" type="checkbox" disabled /> ${feature.name}<span class="learnMore">&quest;</span><div class="moreDesc">${feature.name} $${feature.price}</div></div>`));

            // ADD EVENT LISTENERS
            allBreadCrumbs.on('click', (e) => {
                e.preventDefault();
                const target = e.target.id
                switch (target) {
                    case "firstBreadcrumb":
                        shouldItShow("peopleContainer");
                        checkClasses("firstBreadcrumb");
                        break;
                    case "secondBreadcrumb":
                        shouldItShow("costContainer");
                        checkClasses("secondBreadcrumb");
                        break;
                    case "thirdBreadcrumb":
                        shouldItShow("workoutContainer");
                        checkClasses("thirdBreadcrumb");
                        break;
                    case "fourthBreadcrumb":
                        shouldItShow("travelContainer");
                        checkClasses("fourthBreadcrumb");
                        break;
                    case "fifthBreadcrumb":
                        shouldItShow("productContainer");
                        checkClasses("fifthBreadcrumb");
                        break;
                }
            })

            // CHECK IF CONTAINER SHOULD BE VISIBLE OR NOT
            const shouldItShow = (containerToShow) => {
                containersArray.forEach(element => {
                    const container = element
                    if (container[0].id !== containerToShow) {
                        container.hide();
                    } else {
                        container.show();
                    }
                })
            }

            // CHANGE THE IMAGE WHEN SWITCHING QUESTIONS
            const changeImage = (breadCrumb) => {
                if (breadCrumb === 'firstBreadcrumb') {
                    imageElement.attr('src', imageArray[0]);
                }
                if (breadCrumb === 'secondBreadcrumb') {
                    imageElement.attr('src', imageArray[1]);
                }
                if (breadCrumb === 'thirdBreadcrumb') {
                    imageElement.attr('src', imageArray[2]);
                }
                if (breadCrumb === 'fourthBreadcrumb') {
                    imageElement.attr('src', imageArray[3]);
                }
                if (breadCrumb === 'fifthBreadcrumb') {
                    imageElement.attr('src', imageArray[4]);
                }
            }

            // ADD CLASS TO CLICKED BREADCRUMB
            const checkClasses = (breadCrumb) => {
                breadcrumbsArray.forEach(element => {
                    const crumb = element[0]
                    if (crumb.id !== breadCrumb) {
                        crumb.classList.remove('currentQuestion');
                    } else {
                        crumb.classList.add('currentQuestion');
                    }
                });
                changeImage(breadCrumb);
            }

			// HANDLE INPUT CHANGE
            const handleInput = (e) => {
                const target = e.target
                switch (target.id) {
                    case "totalPeople":
                        numPeople = totalPeopleInput.val();
                        firstBreadcrumb[0].classList.add('questionAnswered');
                        break;
                    case "cost":
                        curCost = totalCostInput.val();
                        secondBreadcrumb[0].classList.add('questionAnswered');
                        break;
                    case "weeklyWorkouts":
                        numWorkouts = totalWorkoutsInput.val();
                        thirdBreadcrumb[0].classList.add('questionAnswered');
                        break;
                    case "travelTime":
                        travelTime = totalTravelInput.val();
                        fourthBreadcrumb[0].classList.add('questionAnswered');
                }
            }

            // GRAB LOOKINGFOR ELEMENT
            const lookingFor = $("#lookingFor");
            const tagList = $("#tagList");

            // ADD OR REMOVE FEATURE
            $(".feature").on("click", (e) => {
                e.preventDefault();
                const featureElement = e.target
                if (!featureElement.classList.contains('feature')) {
                    return;
                }
                if (featureElement.classList.contains('selected')) {
                    featureElement.classList.remove('selected');
                    const checkbox = featureElement.children[0]
                    checkbox.attributes.removeNamedItem('checked');
                    checkbox.setAttribute('disabled', 'disabled');
                } else {
                    featureElement.classList.add('selected');
                    const checkbox = featureElement.children[0];
                    checkbox.attributes.removeNamedItem('disabled');
                    checkbox.setAttribute('checked', 'checked');
                }
                if (jQuery.inArray(featureElement.id, chosenFeatures) != -1) {
                    chosenFeatures = chosenFeatures.filter(item => item != featureElement.id);
                    tagList.empty();
                    chosenFeatures.map(f => {
                        const newTag = `<span class="feature small">${f}</span>`;
                        tagList.append(`${newTag} `)
                    });
                    return;
                }
                chosenFeatures.push(featureElement.id);
                tagList.empty();
                chosenFeatures.map(f => {
                    const newTag = `<span class="feature small">${f}</span>`;
                    tagList.append(`${newTag} `)
                });
            })

            // WHEN TO SHOW OR HIDE MORE POPUP
            const showMore = (target) => {
                const moreDiv = target.target.parentNode
                const allNodes = target.target.parentNode.parentNode.children
                for (const key in allNodes) {
                    if (Object.hasOwnProperty.call(allNodes, key)) {
                        const element = allNodes[key];
                        if (element.id !== moreDiv.id) {
                            element.childNodes[3].classList.remove('showMoreDesc');
                        } else {
                            if (!moreDiv.childNodes[3].classList.contains('showMoreDesc')) {
                                moreDiv.childNodes[3].classList.add('showMoreDesc');
                            } else {
                                moreDiv.childNodes[3].classList.remove('showMoreDesc');
                            }
                        }
                    }
                }
            }

            // GRAB ALL THE FEATURE TAGS
            const allFeatures = $(".feature");

            // HIDES MORE POPUP WHEN BODY IS CLICKED || PASS THE EVENT TO SHOWMORE() || PASS EVENT TO HANDLEINPUT()
            $(document.body).on('click', (e) => {
                e.preventDefault();
                if (e.target.classList.contains('learnMore')) {
                    showMore(e);
                    return;
                }
                if (e.target.tagName == 'SELECT') {
                    handleInput(e);
                    return;
                }
                let index = 0
                while (index < allFeatures.length) {
                    if (allFeatures[index].lastChild.classList.contains('showMoreDesc')) {
                        allFeatures[index].lastChild.classList.remove('showMoreDesc');
                    }
                    index++
                }
            })
        })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Echelon-endorsements"]) return;
  try {
    
  $(document).ready(function() {
    $('.endorsement-list').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="previous carousel-control" type="button" aria-label="Previous"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Left Arrow</title><path d="m22.5 4.563h-17.385l1.941-1.9215c0.13933-0.13708 0.24999-0.30047 0.32552-0.48074s0.11442-0.37373 0.11442-0.56919c0-0.19545-0.03889-0.389-0.11442-0.56927s-0.18619-0.34367-0.32551-0.48074c-0.2827-0.27912-0.66397-0.43561-1.0612-0.43561-0.39727-1e-6 -0.77856 0.15649-1.0612 0.43561l-4.5 4.4565c-0.12624 0.12732-0.22793 0.27674-0.3 0.44091-0.020738 0.04881-0.038281 0.09897-0.052505 0.15006-0.04049 0.11817-0.064718 0.24133-0.072006 0.36603-0.003628 0.04993-0.003628 0.10003-2e-8 0.14996 0.0045823 0.15948 0.035506 0.31707 0.091506 0.46646 0.002795 0.01368 0.006305 0.02725 0.010506 0.04056 0.073035 0.1623 0.17465 0.31018 0.3 0.43652 0.012 0.0135 0.016507 0.03146 0.030007 0.04496l4.5 4.4565c0.28289 0.2788 0.66408 0.435 1.0612 0.435 0.39716 0 0.77837-0.1562 1.0613-0.435 0.13932-0.1371 0.24999-0.3005 0.32552-0.4808s0.11441-0.3737 0.11441-0.5692-0.03888-0.3889-0.11441-0.56918c-0.07553-0.18027-0.1862-0.34376-0.32552-0.48084l-1.941-1.9215 17.378 1e-5c0.2016 0.01111 0.4033-0.01895 0.5928-0.08844 0.1896-0.0695 0.363-0.1769 0.5096-0.31568 0.1467-0.13877 0.2635-0.30601 0.3433-0.49145 0.0798-0.18545 0.121-0.38524 0.121-0.58713s-0.0412-0.40168-0.121-0.58713c-0.0798-0.18544-0.1966-0.35267-0.3433-0.49145-0.1466-0.13878-0.32-0.24618-0.5096-0.31568-0.1895-0.06949-0.3912-0.09964-0.5928-0.08853z" clip-rule="evenodd" class="fill" fill="#fff" fill-rule="evenodd"/></svg></button>',
      nextArrow: '<button class="next carousel-control" type="button" aria-label="Next"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Right Arrow</title><path d="m1.4999 4.563h17.385l-1.941-1.9215c-0.1393-0.13708-0.25-0.30047-0.3255-0.48074s-0.1144-0.37373-0.1144-0.56919c0-0.19545 0.0389-0.389 0.1144-0.56927s0.1862-0.34367 0.3255-0.48074c0.2827-0.27912 0.664-0.43561 1.0613-0.43561 0.3972-1e-6 0.7785 0.15649 1.0612 0.43561l4.5 4.4565c0.1263 0.12732 0.228 0.27674 0.3 0.44091 0.0208 0.04881 0.0383 0.09897 0.0525 0.15006 0.0405 0.11817 0.0647 0.24133 0.072 0.36603 0.0037 0.04993 0.0037 0.10003 0 0.14996-0.0045 0.15948-0.0355 0.31707-0.0915 0.46646-0.0028 0.01368-0.0063 0.02725-0.0105 0.04056-0.073 0.1623-0.1746 0.31018-0.3 0.43652-0.012 0.0135-0.0165 0.03146-0.03 0.04496l-4.5 4.4565c-0.2829 0.2788-0.6641 0.435-1.0612 0.435-0.3972 0-0.7784-0.1562-1.0613-0.435-0.1393-0.1371-0.25-0.3005-0.3255-0.4808s-0.1144-0.3737-0.1144-0.5692 0.0389-0.3889 0.1144-0.56918c0.0755-0.18027 0.1862-0.34376 0.3255-0.48084l1.941-1.9215-17.377 1e-5c-0.20159 0.01111-0.40332-0.01895-0.59287-0.08844-0.18956-0.0695-0.36297-0.1769-0.5096-0.31568-0.14664-0.13877-0.26343-0.30601-0.34325-0.49145-0.079821-0.18545-0.12099-0.38524-0.12099-0.58713s0.041164-0.40168 0.12098-0.58713c0.079823-0.18544 0.19662-0.35267 0.34325-0.49145 0.14664-0.13878 0.32005-0.24618 0.50961-0.31568 0.18955-0.06949 0.39128-0.09964 0.59287-0.08853z" clip-rule="evenodd" fill="#fff" class="fill" fill-rule="evenodd"/></svg></button>',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Echelon-Gallery-Slider"]) return;
  try {
    
$(document).ready(function() {
	let marginLeft = 0;

	const imageWidth = -$('#slider').width();
	const totalLength = ($('.slides').children().length -1) * imageWidth;
	
	const $slider = $('.slides');
	const $arrowLeft = $('.arrow-left');
	const $arrowRight = $('.arrow-right');
	const $thumbs = $('.thumbs');
	const $thumb = $('.thumb');

	const moveSlider = () => $slider.animate({ 'margin-left': `${marginLeft}px` });

    $thumbs.slick({
      dots: false,
      arrows: false,
      slidesToShow: 4, 
      slidesToScroll: 1,
      centerMode: false,
      focusOnSelect: true,
      autoplay: false,
    });

	$arrowLeft.on('click', () => {
		if (marginLeft === 0) {
			marginLeft = totalLength;
			moveSlider();
		} else {
			marginLeft = marginLeft - imageWidth;
			moveSlider();
		}
	});

	$arrowRight.on('click', () => {
		if (marginLeft === totalLength) {
			marginLeft = 0;
			moveSlider();
		} else {
			marginLeft = marginLeft + imageWidth;
			moveSlider();
		}
	});

	$thumb.on('click', (e) => {
		const indexOfThumb = $('.thumb').index(e.target.parentElement);
		switch (indexOfThumb) {
			case 4:
				marginLeft = 0;
				moveSlider();
				break;
			case 5: 
				marginLeft = imageWidth;
				moveSlider();
				break;
			case 6:
				marginLeft = imageWidth * 2;
				moveSlider();
				break;
			case 7:
				marginLeft = imageWidth * 3;
				moveSlider();
				break;
			case 8:
				marginLeft = imageWidth * 4;
				moveSlider();
				break;
			case 9:
				marginLeft = imageWidth * 5;
				moveSlider();
				break;
			case 10:
				marginLeft = imageWidth * 6;
				moveSlider();
				break;
		}
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnc-rules"] && !window.DesignMode) return;
  try {
    
$(document).ready(() => {
	setTimeout(() => {
	const backgroundColor = '#000';
	const formBtn = $('button.dOditb');
	const ctaBtn = $('.buttons-wrapper span a.primary-button');

	$(formBtn).css('background-color', backgroundColor);
	$(ctaBtn).css('background-color', backgroundColor);
	}, 2000);
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

!(function (d) {
    var announcementBannerDesktop = d.getElementById('announcement-content-desktop');
    var announcementBannerMobile = d.getElementById('announcement-content-mobile');
    var announcementData = d.getElementById('announcement-data');
    var sideBarBtn = d.getElementById('side-menu-button-desktop');
    var sideBarBtnMobile = d.getElementById('side-menu-button-mobile');
    var sideBar = d.getElementById('nav-side-bar-desktop');
    var sideBarMobile = d.getElementById('nav-side-bar-mobile');
    var background = d.getElementById('nav-background-screen');
    var closeBtn = d.getElementById('close-btn-desktop');
    var closeBtnMobile = d.getElementById('close-btn-mobile');
    var pageContent = d.getElementById('page-content');
    var footer = d.getElementById('shopify-section-footer');

    function blockBackground() {
        pageContent.classList.add('frozen');
        background.classList.add('active');
        footer.style.display = 'none';
    }

    function unblockBackground() {
        pageContent.classList.remove('frozen');
        background.classList.remove('active');
        footer.style.display = 'block';
    }

    // Mobile - Close the side bar
    function closeMobileSideBar() {
        sideBarMobile.classList.remove('active');
        sideBarBtnMobile.style.display = 'block';
        closeBtnMobile.style.display = 'none';
    }

    // Desktop - Close the side bar
    function closeSideBar() {
        sideBar.classList.remove('active');
        closeMobileSideBar();
        unblockBackground();
    }

    // Desktop and Mobile - Close the side bar
    background.addEventListener('click', closeSideBar);
    closeBtn.addEventListener('click', closeSideBar);

    // Mobile - Open the side bar on button click
    sideBarBtnMobile.addEventListener('click', function () {
        sideBarMobile.classList.add('active');
        sideBarBtnMobile.style.display = 'none';
        closeBtnMobile.style.display = 'block';

        blockBackground();
    });

    // Mobile - Close the side bar
    closeBtnMobile.addEventListener('click', function () {
        closeMobileSideBar();
        unblockBackground();
    });

    // Announcement bar
    function populateAnnouncementBanner() {
        var data = [];
        if (announcementData.dataset.text_1 != "") {
            data.push({
                text: announcementData.dataset.text_1,
                url: announcementData.dataset.url_1
            });
        }
        if (announcementData.dataset.text_2 != "") {
            data.push({
                text: announcementData.dataset.text_2,
                url: announcementData.dataset.url_2
            });
        }
        if (announcementData.dataset.text_3 != "") {
            data.push({
                text: announcementData.dataset.text_3,
                url: announcementData.dataset.url_3
            });
        }

        for (var i = 0; i < data.length; i++) {
            var textElement = null;
            if (data[i].url != "") {
                textElement = `<a href="${
                    data[i].url
                }" class="announcement-text trigger-popup  ${
                    i == 0
                        ? 'visible'
                        : ''
                    }">${
                        data[i].text
                    }</a>`;
            } else {
                textElement = `<p class="announcement-text trigger-popup  ${
                    i == 0
                        ? 'visible'
                        : ''
                    }">${
                        data[i].text
                    }</p>`;
            }
            var desktopTemplate = d.createElement('template');
            var mobileTemplate = d.createElement('template');
            desktopTemplate.innerHTML = textElement;
            mobileTemplate.innerHTML = textElement;
            announcementBannerMobile.append(desktopTemplate.content.firstChild);
            announcementBannerDesktop.append(mobileTemplate.content.firstChild);

        }

        // Shuffle through the announcements
        var activeIndex = 0;
        if (data.length > 1) {
            setInterval(function () {
                announcementBannerDesktop.childNodes[activeIndex].classList.remove('visible');
                announcementBannerMobile.childNodes[activeIndex].classList.remove('visible');
                if (activeIndex == data.length - 1) {
                    activeIndex = 0;
                } else {
                    activeIndex++;
                }
                announcementBannerDesktop.childNodes[activeIndex].classList.add('visible');
                announcementBannerMobile.childNodes[activeIndex].classList.add('visible');
            }, 6000);
        }
    }
    populateAnnouncementBanner();

}(document));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["MothersDay-Slider"]) return;
  try {
    
  $(document).ready(function() {
    $('.endorsement-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="previous carousel-control" type="button" aria-label="Previous"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Left Arrow</title><path d="m22.5 4.563h-17.385l1.941-1.9215c0.13933-0.13708 0.24999-0.30047 0.32552-0.48074s0.11442-0.37373 0.11442-0.56919c0-0.19545-0.03889-0.389-0.11442-0.56927s-0.18619-0.34367-0.32551-0.48074c-0.2827-0.27912-0.66397-0.43561-1.0612-0.43561-0.39727-1e-6 -0.77856 0.15649-1.0612 0.43561l-4.5 4.4565c-0.12624 0.12732-0.22793 0.27674-0.3 0.44091-0.020738 0.04881-0.038281 0.09897-0.052505 0.15006-0.04049 0.11817-0.064718 0.24133-0.072006 0.36603-0.003628 0.04993-0.003628 0.10003-2e-8 0.14996 0.0045823 0.15948 0.035506 0.31707 0.091506 0.46646 0.002795 0.01368 0.006305 0.02725 0.010506 0.04056 0.073035 0.1623 0.17465 0.31018 0.3 0.43652 0.012 0.0135 0.016507 0.03146 0.030007 0.04496l4.5 4.4565c0.28289 0.2788 0.66408 0.435 1.0612 0.435 0.39716 0 0.77837-0.1562 1.0613-0.435 0.13932-0.1371 0.24999-0.3005 0.32552-0.4808s0.11441-0.3737 0.11441-0.5692-0.03888-0.3889-0.11441-0.56918c-0.07553-0.18027-0.1862-0.34376-0.32552-0.48084l-1.941-1.9215 17.378 1e-5c0.2016 0.01111 0.4033-0.01895 0.5928-0.08844 0.1896-0.0695 0.363-0.1769 0.5096-0.31568 0.1467-0.13877 0.2635-0.30601 0.3433-0.49145 0.0798-0.18545 0.121-0.38524 0.121-0.58713s-0.0412-0.40168-0.121-0.58713c-0.0798-0.18544-0.1966-0.35267-0.3433-0.49145-0.1466-0.13878-0.32-0.24618-0.5096-0.31568-0.1895-0.06949-0.3912-0.09964-0.5928-0.08853z" clip-rule="evenodd" class="fill" fill="#fff" fill-rule="evenodd"/></svg></button>',
      nextArrow: '<button class="next carousel-control" type="button" aria-label="Next"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Right Arrow</title><path d="m1.4999 4.563h17.385l-1.941-1.9215c-0.1393-0.13708-0.25-0.30047-0.3255-0.48074s-0.1144-0.37373-0.1144-0.56919c0-0.19545 0.0389-0.389 0.1144-0.56927s0.1862-0.34367 0.3255-0.48074c0.2827-0.27912 0.664-0.43561 1.0613-0.43561 0.3972-1e-6 0.7785 0.15649 1.0612 0.43561l4.5 4.4565c0.1263 0.12732 0.228 0.27674 0.3 0.44091 0.0208 0.04881 0.0383 0.09897 0.0525 0.15006 0.0405 0.11817 0.0647 0.24133 0.072 0.36603 0.0037 0.04993 0.0037 0.10003 0 0.14996-0.0045 0.15948-0.0355 0.31707-0.0915 0.46646-0.0028 0.01368-0.0063 0.02725-0.0105 0.04056-0.073 0.1623-0.1746 0.31018-0.3 0.43652-0.012 0.0135-0.0165 0.03146-0.03 0.04496l-4.5 4.4565c-0.2829 0.2788-0.6641 0.435-1.0612 0.435-0.3972 0-0.7784-0.1562-1.0613-0.435-0.1393-0.1371-0.25-0.3005-0.3255-0.4808s-0.1144-0.3737-0.1144-0.5692 0.0389-0.3889 0.1144-0.56918c0.0755-0.18027 0.1862-0.34376 0.3255-0.48084l1.941-1.9215-17.377 1e-5c-0.20159 0.01111-0.40332-0.01895-0.59287-0.08844-0.18956-0.0695-0.36297-0.1769-0.5096-0.31568-0.14664-0.13877-0.26343-0.30601-0.34325-0.49145-0.079821-0.18545-0.12099-0.38524-0.12099-0.58713s0.041164-0.40168 0.12098-0.58713c0.079823-0.18544 0.19662-0.35267 0.34325-0.49145 0.14664-0.13878 0.32005-0.24618 0.50961-0.31568 0.18955-0.06949 0.39128-0.09964 0.59287-0.08853z" clip-rule="evenodd" fill="#fff" class="fill" fill-rule="evenodd"/></svg></button>',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-reusable-carousel"] && !window.DesignMode) return;
  try {
    
  
	document.addEventListener( 'DOMContentLoaded', function () {
		 new Splide('.splide', {

    type: 'loop',
    perPage: 3,
    focus: 'center',
    autoplay: true,
    interval: 8000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: true,
    padding: '10%',
    throttle: 300,
    breakpoints: {
      1440: {
        perPage: 1,
        padding: '30%'
      }
    }
  }).mount();
	} );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitbull-rules"] && !window.DesignMode) return;
  try {
    
$(document).ready(() => {
	setTimeout(() => {
	const backgroundColor = '#000';
	const formBtn = $('button.dOditb');
	const ctaBtn = $('.buttons-wrapper span a.primary-button');

	$(formBtn).css('background-color', backgroundColor);
	$(ctaBtn).css('background-color', backgroundColor);
	}, 2000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reusable-experience-section"] && !window.DesignMode) return;
  try {
    
 var controller = new ScrollMagic.Controller();

  $(function () {
    $(".experience-items .image-container").each((index) => {
        const id = "#trigger" + index;
        var scene = new ScrollMagic.Scene({
            triggerElement: id,
            triggerHook: 'onEnter',
        })
        .setClassToggle("#pin" + index, 'active')
        .addTo(controller);
    });
    
    var scene = new ScrollMagic.Scene({
        triggerElement: "#endTrigger",
        triggerHook: 'onEnter'
    })
    .setClassToggle(".experience-items .image-container", 'complete')
    .addTo(controller);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reusable-info-slider"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function() {
      var $carousel = $('.carousel__inner');

      var settings = {
        dots: false,
        arrows: false,
        slide: '.slick-slideshow__slide',
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '60px',
      };

      function setSlideVisibility() {
        //Find the visible slides i.e. where aria-hidden="false"
        var visibleSlides = $carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
        //Make sure all of the visible slides have an opacity of 1
        $(visibleSlides).each(function() {
          $(this).css('opacity', 1);
        });

        //Set the opacity of the first and last partial slides.
        $(visibleSlides).first().prev().css('opacity', 0);
      }

      $carousel.slick(settings);
      $carousel.slick('slickGoTo', 1);
      setSlideVisibility();

      $carousel.on('afterChange', function() {
        setSlideVisibility();
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reusable-product-description"]) return;
  try {
    

$(document).ready(() => {
    let marginLeft = 0;

    let imageWidth = -$('.slide').width();
    let windowWidth = $(window).width();

    const totalLength = ($('.slides').children().length - 1) * imageWidth;
    const numOfSlides = $('.slides').children().length - 1;

    const $thumbRow = $('.thumbnail-row');
    const $thumbNails = $('.thumbnail');

    const $slider = $('#slider');

    const moveSlider = () => $slider.animate({
        'margin-left': `${marginLeft}px`
    });

    function setSlick() {
        $thumbRow.slick({
            dots: false,
            arrows: false,
            slidesToShow: 5,
            swipeToSlide: true,
            centerMode: false,
            focusOnSelect: true,
            autoplay: false,
            infinite: true,
            swipe: true,
            touchMove: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        infinite: true
                    }
                }, {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        infinite: true
                    }
                }
            ]
        });
    }

    setSlick();

    $(window).on('resize', () => {
        windowWidth = $(this).width();
        imageWidth = -$('.slide img').width();
    });

    $thumbNails.on('click', (e) => {
        imageWidth = -$('.slide img').width();
        const targetObj = e.target.parentElement.attributes
        const index = [... targetObj].filter(property => property.localName === "data-slick-index")[0].value;
        if (index === 0) {
            marginLeft = 0;
            moveSlider();
            return;
        }

        marginLeft = imageWidth * index
        moveSlider();

    });

    $(window).on('click', (e) => {
        const targetObj = e.target.parentElement.attributes
        const index = [... targetObj].filter(property => property.localName === "data-slick-index")[0].value;
        if (index == numOfSlides) {
            console.log('on the model slide');
        }
        if (index > numOfSlides) {
            marginLeft = 0;
            moveSlider();
        }
    });

    let selectedColor = document.querySelectorAll(".color-swatch")
    for (var i = 0; i < selectedColor.length; i++) {
        selectedColor[i].addEventListener("click", function () {
            const VarientSelected = this.getAttribute('data-id');
        });
    }

    $('.color-swatch').click((event) => {
        var element = event.target;

        // Check to see if the SVG has been clicked instead of the swatch
        if (element.tagName == 'svg') {
            element = event.target.parentElement;
        }

        // Get variant data from the swatch
        var variantId = $(element).data('id');
        var variantName = $(element).data('name');

        // Dispatch the custom event to update the buy now buttons
        var variantEvent = new CustomEvent('variant-selected', {
            detail: variantId
        });
        window.dispatchEvent(variantEvent);

        // Update the selected swatch
        $('.color-swatch').removeClass('selected');
        $(element).addClass('selected');
        $('.select-title span').text(variantName);
    });

});

(function () {
    const mobileARBtn = document.querySelector(".ar");
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        mobileARBtn.style.display = "block"
    } else {
        mobileARBtn.style.display = "none"
    }
})();


  } catch(e) { console.error(e); }
})();

})();
